import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { cloneDeep } from 'lodash';

export interface MapSettingsSlice {
  zoom: number;
  center: {
    lat: number;
    lng: number;
  }
  selection_zoom: number,
  selection_center: {
    lat: number;
    lng: number;
  }
}

export interface MapSettingsEditSlice {
  zoom: number;
  center: {
    lat: number;
    lng: number;
  }
}

const initialState: MapSettingsSlice = { 
  zoom: 5, 
  center: {
    lat: 54.501280,
    lng: -1.477420
  },
  selection_zoom: null,
  selection_center: {
    lat: null,
    lng: null
  }
};

export const mapSettingsSlice = createSlice({
  name: 'mapSettings',
  initialState,
  reducers: {
    updateZoom: (state, action: PayloadAction<MapSettingsEditSlice>) => {
      // console.log(action.payload);
      if(action.payload.zoom > 18){
        action.payload.zoom = 18;
      }
      state.zoom = action.payload.zoom;
      state.center = action.payload.center;
    },
    updateSelectionZoom: (state, action: PayloadAction<MapSettingsEditSlice>) => {
      state.selection_zoom = action.payload.zoom;
      state.selection_center = action.payload.center;
    },
    resetZoom: (state) => {
      state.zoom = state.selection_zoom;
      state.center = cloneDeep(state.selection_center);
    }
  }
});

export const { updateZoom, updateSelectionZoom, resetZoom } = mapSettingsSlice.actions;

export const selectMapSettings = (state: RootState) => state.mapSettings;

export default mapSettingsSlice.reducer;
